import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { tabStandard } from '@sparta.global.helpers/tab-standard-helper/dist/es5.js';
import { cardHelper } from '@sparta.global.helpers/card-helper/dist/es5.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es5.js';
function toCurrency(num) {
  if (num == null) return '0.00';
  var sign = /^\s*-/.test(num) ? '-' : '';
  var transformedNum = num;
  if (typeof num === 'string') {
    transformedNum = Number(num.replace(/[^0-9.]+/g, ''));
  } else if (typeof num === 'number') {
    transformedNum = Math.abs(num);
  } else {
    transformedNum = 0;
  }
  var magnitude = transformedNum.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  return "".concat(sign).concat(magnitude);
}
function renderHeaderCopy() {
  return "\n      <div\n        role=\"heading\"\n        {{#if level}}aria-level=\"{{ level }}\"{{/if}}\n        {{#if id}}id=\"{{ id }}\"{{/if}}\n        class=\"{{#if class}}{{ class }}{{else}}form-headline{{/if}}\"\n      >\n        {{{ heading }}}\n      </div>";
}

/**
 * Sparta V6 migrated "renderHeaderCopy" using proper handlebars standards.
 * @param {object} copy JCR passed to the helper (should contain level, id, class, heading)
 * @param {Number|Object} index Optional index, if not given handlebars will default to helperInfo
 * @returns {string} The compiled response in raw HTML (not handlebars).
 */
function renderHeader(copy, index) {
  var level = copy.level,
    heading = copy.heading,
    tag = copy.tag;
  var tagName = tag || "h".concat(level);
  var text = typeof index === 'number' ? "".concat(heading, " ").concat(index) : heading;
  // Adds an attribute if its present in the copy, otherwise returns an empty string
  var optionalAttr = function optionalAttr(name) {
    return copy[name] ? "".concat(name, "=\"").concat(copy[name], "\"") : '';
  };
  return "\n    <".concat(tagName, " ").concat(optionalAttr('id'), " ").concat(optionalAttr('class'), ">\n      ").concat(text, "\n    </").concat(tagName, ">\n  ");
}
function renderHeaderCopyWithToolTip() {
  return "\n      <div\n        role=\"heading\"\n        {{#if level}}aria-level=\"{{ level }}\"{{/if}}\n        {{#if id}}id=\"{{ id }}\"{{/if}}\n        class=\"{{#if class}}{{ class }}{{else}}form-headline{{/if}}\"\n      >\n        {{{ heading }}}\n        <span class=\"sub-heading\">\n        {{{ link whyLabel }}}\n        {{#layerContent whyTooltip}}\n            <p>{{{ whyTooltip.content.description }}}</p>\n        {{/layerContent}}     \n        </span>\n      </div>";
}
function renderPageLevelErrorMessages() {
  return '<div class="page-level-message"></div>';
}
function curve(position, color, cssClass) {
  var curvePosition = typeof position === 'string' && position ? position : 'both';
  var fillColor = typeof color === 'string' && color ? color : '#fff';
  var cssClassString = typeof cssClass === 'string' && cssClass ? cssClass : '';
  var positions = {
    top: "\n        <svg class=\"curve-top ".concat(cssClassString, "\" viewBox=\"0 0 1400 38\" preserveAspectRatio=\"xMidYMid slice\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path d=\"M 0 38 L 0 0 L 1400 0.121 C 1346.561 0.952 1159.562 3.294 1106.153 3.435 C 1088.943 3.481 1071.736 3.614 1054.531 3.833 C 972.139 4.896 889.72 6.585 807.317 8.093 C 724.914 9.6 642.556 11.243 560.165 13.659 C 524.467 14.706 488.635 15.911 452.924 16.757 C 371.192 18.694 289.508 21.909 207.863 26.028 C 182.189 27.311 156.519 28.657 130.851 30.061\" shape-rendering=\"geometricPrecision\" style=\"fill:").concat(fillColor, ";\"/>\n        </svg>\n      "),
    bottom: "\n        <svg height=\"50\" class=\"curve-bottom show-for-large-up ".concat(cssClassString, "\" focusable=\"false\" style=\"width:100%; margin-bottom: -1px;\" viewBox=\"0 0 1920 50\" preserveAspectRatio=\"xMidYMid slice\" xmlns=\"http://www.w3.org/2000/svg\">\n        <title></title>\n        <path d=\"M0,50C316.433,19.774,637.707,12.973,956.4,12.545,1278.229,12.113,1600.312,21.087,1920,50\" style=\"fill: #fff\"/>\n        </svg>\n\n        <svg height=\"34\" class=\"curve-bottom show-for-medium-only  ").concat(cssClassString, "\" focusable=\"false\" style=\"width:100%; margin-bottom: -1px;\" viewBox=\"0 0 1024 34\" preserveAspectRatio=\"xMidYMid slice\" xmlns=\"http://www.w3.org/2000/svg\">\n        <title></title>\n        <path d=\"M0,34C334.1,3.387,689.917,5.016,1024,34\" style=\"fill: #fff\"/>\n        </svg>\n\n        <svg height=\"34\" class=\"curve-bottom show-for-small-only ").concat(cssClassString, "\" focusable=\"false\" style=\"width:100%; margin-bottom: -1px;\" viewBox=\"0 0 768 34\" preserveAspectRatio=\"xMidYMid slice\" xmlns=\"http://www.w3.org/2000/svg\">\n        <title></title>\n        <path d=\"M0,34C246.961,.241,521.075,1.585,768,34\" style=\"fill: #fff\"/>\n        </svg>\n      ")
  };
  return position === 'both' ? positions.top + positions.bottom : positions[curvePosition];
}
function iconHelper(type) {
  if (type === 'arrow') {
    return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30" focusable="false"><title></title><path d="M22.64,13.324L18.218,8.977a1.338,1.338,0,0,0-1.87,0,1.283,1.283,0,0,0-.024,1.814l0.024,0.024,3,2.953L7.838,13.64H7.822a1.3,1.3,0,0,0-.086,2.589h0.07l11.431,0.133L16.288,19.17a1.285,1.285,0,0,0-.05,1.817l0.021,0.021a1.339,1.339,0,0,0,1.87.029l4.483-4.271A2.388,2.388,0,0,0,22.7,13.39l-0.064-.065" style="fill: #538bb4"/></svg>';
  }
  if (type === 'bordered-arrow') {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" focusable="false"><title></title><circle cx="15" cy="15" r="14.5" fill="none"/><path d="M15 29.5a14.5 14.5 0 1 1 14.5-14.5 14.517 14.517 0 0 1-14.5 14.5zm0-27a12.5 12.5 0 1 0 12.5 12.5 12.514 12.514 0 0 0-12.5-12.5z" fill="#fff"/><path fill="none" d="M-269.5-392.404h320v1122h-320z"/><path d="M22.64 13.324l-4.422-4.347a1.338 1.338 0 0 0-1.87 0 1.283 1.283 0 0 0-.024 1.814l.024.024 3 2.953-11.51-.128h-.016a1.3 1.3 0 0 0-.086 2.589h.07l11.431.133-2.949 2.808a1.285 1.285 0 0 0-.05 1.817l.021.021a1.339 1.339 0 0 0 1.87.029l4.483-4.271a2.388 2.388 0 0 0 .088-3.376l-.064-.065" fill="#fff"/></svg>';
  }
  if (type === 'caret') {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6.354" viewBox="0 0 10 6.354" focusable="false"><title></title><path d="M0,1.354L1.352,0,5,3.647,8.646,0,10,1.352l-5,5Z" /></svg>';
  }
  console.error('icon not found');
  return '';
}
function contains(key, value, options) {
  if (key.includes(value)) {
    return options.fn(this);
  }
  return options.inverse(this);
}
function house() {
  return "<div class=\"house-container\">\n        <div class=\"house-background\">\n          <div class=\"house\">\n            <div class=\"roof\"></div>\n            <div class=\"structure\"></div>\n            <div class=\"chimney\"></div>\n            <div class=\"door\"></div>\n            <div class=\"door-open\"></div>\n            <div class=\"structure-bottom-half-fill\"></div>\n            <div class=\"bottom-to-structure-fill\"></div>\n            <div class=\"bottom-from-structure-fill\"></div>\n            <div class=\"top-from-structure-fill-sixty\"></div>\n            <div class=\"top-from-structure-fill-seventy\"></div>\n            <div class=\"top-from-structure-fill-eighty\"></div>\n            <div class=\"top-from-structure-fill-ninety\"></div>\n            <div class=\"top-from-structure-fill-ninety\"></div>\n            <div class=\"top-to-structure-fill-sixty\"></div>\n            <div class=\"top-to-structure-fill-seventy\"></div>\n            <div class=\"top-to-structure-fill-eighty\"></div>\n            <div class=\"top-to-structure-fill-ninety\"></div>\n            <div class=\"top-to-structure-fill-one-hundred\"></div>\n            <div class=\"basic-spinner intro-screen\">\n          </div>\n        </div>\n      </div>\n    </div>";
}

/**
 * Performs a logical or operation on all arguments given
 * @example
 * {{#if (logicalOr variableA (logicalAnd variableB (logicalNot variableC)))}}
 * @param  {...Boolean} args Arguments
 * @returns {Boolean} Output of OR operation
 */
function logicalOr() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.slice(0, -1).some(function (x) {
    return x;
  });
}

/**
 * Performs a logical and operation on all arguments given
 * @example
 * {{#if (logicalOr variableA (logicalAnd variableB (logicalNot variableC)))}}
 * @param  {...Boolean} args Arguments
 * @returns {Boolean} Output of AND operation
 */
function logicalAnd() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return args.slice(0, -1).every(function (x) {
    return x;
  });
}

/**
 * Performs a logical NOT operation on the argument
 * @example
 * {{#if (logicalOr variableA (logicalAnd variableB (logicalNot variableC)))}}
 * @param {Boolean} arg Argument
 * @returns {Boolean} Inverse of given input
 */
function logicalNot(arg) {
  return !arg;
}

/**
 * Creates tab navigation using global Sparta's tab navigation helper allowing
 * for an iterative approach the same way #each works.
 * @param {Object} partials Handlebars partials (unused) to be sent to Tab-Navigation
 * @param {Array<Object>} products Handlebars context / full product info
 * @param {Array<Object>} productTypes Handlebars context / tab labels
 * @param {Object} options Handlebars options
 * @returns {String} Compiled HTML string
 */
function productTabNavigation(partials, products, productTypes, options) {
  // For whatever reason, the backend may send the same product code multiple times.
  // To deal with this, we filter by the first of each product code to ensure unique
  // items are present.
  var productCodes = Array.from(Object.keys(products), function (k) {
    return products[k].productTypeCode;
  });
  var content = Array.from(Object.keys(products), function (k) {
    return products[k];
  }).filter(function (p, idx) {
    return idx === productCodes.indexOf(p.productTypeCode);
  });
  var tabs = Array.from(Object.keys(productTypes), function (k) {
    return productTypes[k];
  }).filter(function (tab) {
    return tab.content != null;
  });

  // Construct tab nav JCR
  var jcr = {
    level: 2,
    tabs: tabs.map(function (type, idx) {
      var tab = {
        label: type.content,
        id: type.ID,
        options: type.actionType.options
      };
      if (content[idx]) tab.panel = {
        content: options.fn(content[idx])
      };else {
        // Our requirement is that the "other" tab must open a modal. Unfortunately tab
        // navigation does not support buttons being used for custom actions, and only
        // supports links not opening tabs. Hence we're forced to use a link.
        tab.type = 'link';
        tab.URL = type.URL;
      }
      return tab;
    })
  };

  // Return global tab nav helper
  return tabStandard(partials, jcr);
}

/**
 * Creates a card on the page as a block helper rather than with partials or all html in a string.
 * This allows us to make cards using global sparta without defining separate partials breaking
 * DME's architecture.
 * @param {Object} partials Site partials (unused)
 * @param {Object} jcr JCR to pass to the card helper
 * @param {Object} context Handlebars context
 * @param {Object} options Handlebars options
 * @returns {String} Compiled HTML String
 */
function cardBlockHelper(partials, jcr, context, options) {
  return cardHelper(partials, // We compile the block content and pass it to the card helper. We merge this
  // with existing card JCR.
  _objectSpread(_objectSpread({}, jcr), {}, {
    markup: _objectSpread(_objectSpread({}, jcr.markup), {}, {
      content: options.fn(context)
    })
  }), context);
}

/**
 * This helper allows for indexed remove buttons in routes which have dynamic re-compiled
 * partials with grouped sections. Adding this as a helper allows for common code with
 * minimal JS change.
 * @param {Object} config Config passed to the button helper
 * @param {Number} index The index associated to this button
 * @returns {String} Compiled button html
 */
function indexedRemoveButton(config, index) {
  return button(_objectSpread(_objectSpread({}, config), {}, {
    adaText: "".concat(config.adaText, " ").concat(index)
  }));
}

/**
 * This helper provide the classes for layout which supports all the breakpoints
 * @note  Changing this will affects the layout of all routes.
 * @returns {String} Colum classes for default layout
 */
function columnDefaultLayout() {
  return 'small-12 medium-8 large-6 medium-offset-2 large-offset-3';
}

/**
 * This helper provide the classes for MLO containers
 * @note  Changing this will affect all routes containing MLO details.
 * @returns {String} MLO container alignment classes.
 */
function mloDefaultLayout() {
  return 'small-12 medium-6 medium-offset-3 large-4 large-offset-4';
}

/**
 * This helper creates the action buttons at the bottom of all routes in DME.
 * @note Changing this affects all routes in DME, modify with caution.
 * @param {...Object} Ordered list of button JCRs to be passed to the button helper.
 * Primary should be passed first, tertiary should be passed last.
 * @returns {String} The formatted HTML for all action buttons, suitable for displaying.
 */
function actionButtons() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return "<div class=\"action-buttons\">\n    ".concat(args.filter(function (x) {
    return x && x.content && x.content !== '';
  }).map(button).join(''), "\n  </div>");
}

/**
 * This helper creates the action buttons at the bottom of tile all routes in DME.
 * @note Changing this affects all tile routes in DME, modify with caution.
 * @param {Array<Object>} buttons Ordered list of button JCRs to be passed to the button helper.
 * Primary should be passed **last**, tertiary should be passed **first**. - This is the opposite
 * order of actionButtons, for legacy reasons.
 * @returns {String} The formatted HTML for all action buttons, suitable for displaying.
 */
function tileActionButtons(buttons) {
  if (buttons == null) return '';
  var buttonsArr = buttons;
  // Handlebars sometimes passes the array in the format of an object with numbered keys, ie:
  // { 0: {}, 1: {}, 2: {}, ... }
  if (!Array.isArray(buttonsArr)) {
    buttonsArr = Object.keys(buttons).sort(function (a, b) {
      return Number(a) - Number(b);
    }).map(function (key) {
      return buttons[key];
    });
  }
  return actionButtons.apply(void 0, _toConsumableArray(buttonsArr.reverse()));
}

/**
 * This helper converts the input into 3 decimal places, and displays it as a percentage.
 * 3 decimal places are always displayed, regardless of the original length.
 * @param {String|Number} rate The input rate.
 * @returns {String} Formatted rate suitable for displaying.
 */
function toRate(rate) {
  return "".concat(Number(rate.toString().replace(/[^0-9.-]/g, '')).toFixed(3), "%");
}
export { actionButtons, cardBlockHelper, columnDefaultLayout, contains, curve, house, iconHelper, indexedRemoveButton, logicalAnd, logicalNot, logicalOr, mloDefaultLayout, productTabNavigation, renderHeader, renderHeaderCopy, renderHeaderCopyWithToolTip, renderPageLevelErrorMessages, tileActionButtons, toCurrency, toRate };